import type { GetWidgetManifestFn } from '@wix/yoshi-flow-editor/blocks';

export const getWidgetManifest: GetWidgetManifestFn = (widgetBuilder) =>
  widgetBuilder.configureConnectedComponents('title', (builder) =>
    builder.behavior().set({ dataEditOptions: 'TEXT_STYLE_ONLY' }),
  );
